__turbopack_context__.v({
  "dark": "WaveDivider-module-scss-module__MYFHuG__dark",
  "flip": "WaveDivider-module-scss-module__MYFHuG__flip",
  "magenta": "WaveDivider-module-scss-module__MYFHuG__magenta",
  "wave": "WaveDivider-module-scss-module__MYFHuG__wave",
  "yellow": "WaveDivider-module-scss-module__MYFHuG__yellow",
});
